import styled, { css } from "styled-components";

export const fontFamilyDefault = '"Museo Sans", sans-serif';
export const fontFamilySerif = '"PT Serif", sans-serif';

interface HeadingProps {
  scale: 1 | 2 | 3 | 4;
}

export const headingStyle = ({ scale }: HeadingProps) => {
  switch (scale as any) {
    case 1:
      return css`
        font: 32px/40px ${fontFamilySerif};
      `;
    case 2:
      return css`
        font: 28px/36px ${fontFamilySerif};
      `;
    case 3:
      return css`
        font: 22px/30px ${fontFamilySerif};
      `;
    case 4:
      return css`
        font: 32px/48px ${fontFamilyDefault};
      `;
    default:
      return null;
  }
};

export const Heading1 = styled.h1`
  ${headingStyle({ scale: 1 })};
`;

export const Heading2 = styled.h2`
  ${headingStyle({ scale: 2 })};
`;

export const Heading3 = styled.h3`
  ${headingStyle({ scale: 3 })};
`;

export const Heading4 = styled.h4`
  ${headingStyle({ scale: 4 })};
`;

interface ParagraphProps {
  large?: boolean;
}

export const Paragraph = styled.p<ParagraphProps>`
  font: 16px/24px ${fontFamilyDefault};

  ${(props) =>
    props.large &&
    css`
      font-size: 18px;
      line-height: 26px;
    `};
`;
